import API from 'API'

export const START_LOAD_STATIONS = 'START_LOAD_STATIONS'
export const SUCCESS_LOAD_STATIONS = 'SUCCESS_LOAD_STATIONS'
export const ERROR_LOAD_STATIONS = 'ERROR_LOAD_STATIONS'

export const loadStations =
  (forceReload = false) =>
  (dispatch, getState) => {
    const {stations} = getState()
    const hasStations = Array.isArray(stations?.spp) && Array.isArray(stations?.wpp)
    const isAlreadyLoaded = hasStations && stations.spp.length > 0 && stations.wpp.length > 0

    if (!forceReload && (stations?.isLoading || isAlreadyLoaded || stations?.isLoaded)) {
      return
    }

    dispatch({type: START_LOAD_STATIONS})
    API.getStations()
      .then(({data}) => {
        dispatch({
          type: SUCCESS_LOAD_STATIONS,
          data,
        })
      })
      .catch(error => {
        console.error('LOAD_STATIONS error:', error)
        dispatch({
          type: ERROR_LOAD_STATIONS,
          error: error.message || 'Failed to load stations',
        })
      })
  }
